import * as React from 'react';

function SvgAnnouncement(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={50} height={50} {...props}>
      <defs>
        <style>{`.announcement_svg__prefix__cls-2{fill:${props.fill}}`}</style>
      </defs>
      <g id="announcement_svg__prefix__announcement" transform="translate(-26 -113)">
        <path
          id="announcement_svg__prefix__bounds"
          fill="none"
          d="M0 0h50v50H0z"
          transform="translate(26 113)"
        />
        <g id="announcement_svg__prefix__megaphone" transform="translate(27 120)">
          <g
            id="announcement_svg__prefix__Group_2272"
            data-name="Group 2272"
            transform="translate(0 .001)"
          >
            <path
              id="announcement_svg__prefix__Path_5113"
              d="M4.69 23.449h.938v9.379a3.752 3.752 0 007.5 0v-9.379h1.876a41.655 41.655 0 0115.724 3.291 21.2 21.2 0 013.224 1.9v2.312a.938.938 0 101.876 0v-9.738l3.234-1.614a.938.938 0 00.518-.839v-5.63a.938.938 0 00-.518-.839l-3.233-1.616V.938a.938.938 0 00-1.876 0V3.25a21.277 21.277 0 01-3.224 1.9 41.658 41.658 0 01-15.722 3.292H4.69A4.7 4.7 0 000 13.131v5.628a4.7 4.7 0 004.69 4.69zm6.565 1.876h-.938a.938.938 0 100 1.876h.938v1.876h-.938a.938.938 0 100 1.876h.938v1.876a1.876 1.876 0 11-3.752 0v-9.38h3.752zM37.7 13.711v4.468l-1.876.938v-6.344zM33.953 5.5v20.886a17.977 17.977 0 00-1.876-1.076v-5.144a.938.938 0 10-1.876 0v4.3a45.291 45.291 0 00-14.256-2.881V10.3A45.306 45.306 0 0030.2 7.421v4.3a.938.938 0 101.876 0V6.58a18.04 18.04 0 001.877-1.08zM1.876 13.131a2.817 2.817 0 012.814-2.813h9.379v11.255H4.69a2.817 2.817 0 01-2.814-2.814zm0 0"
              className="announcement_svg__prefix__cls-2"
              data-name="Path 5113"
              transform="translate(0 -.001)"
            />
            <path
              id="announcement_svg__prefix__Path_5114"
              d="M462 160.938a.938.938 0 00.938.938h2.814a.938.938 0 000-1.876h-2.814a.938.938 0 00-.938.938zm0 0"
              className="announcement_svg__prefix__cls-2"
              data-name="Path 5114"
              transform="translate(-418.668 -144.993)"
            />
            <path
              id="announcement_svg__prefix__Path_5115"
              d="M437.945 53.295l2.437-1.407a.938.938 0 10-.938-1.625l-2.438 1.407a.938.938 0 00.938 1.625zm0 0"
              className="announcement_svg__prefix__cls-2"
              data-name="Path 5115"
              transform="translate(-395.594 -45.435)"
            />
            <path
              id="announcement_svg__prefix__Path_5116"
              d="M437.007 256.887l2.438 1.407a.938.938 0 10.938-1.625l-2.437-1.407a.938.938 0 00-.938 1.625zm0 0"
              className="announcement_svg__prefix__cls-2"
              data-name="Path 5116"
              transform="translate(-395.594 -231.207)"
            />
            <path
              id="announcement_svg__prefix__Path_5117"
              d="M323.876 160.938a.938.938 0 11-.938-.938.938.938 0 01.938.938zm0 0"
              className="announcement_svg__prefix__cls-2"
              data-name="Path 5117"
              transform="translate(-291.799 -144.993)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgAnnouncement;
